/**
 * @generated SignedSource<<80bfb8c0b60c843ceb4234511f12fe82>>
 * @relayHash cde8ec2dd51d3aa6be3ca93bf54e9722
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID cde8ec2dd51d3aa6be3ca93bf54e9722

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propositionId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "offerType",
        "variableName": "offerType"
      },
      {
        "kind": "Variable",
        "name": "propositionId",
        "variableName": "propositionId"
      }
    ],
    "concreteType": "GenerateContractNumbersMutationResponse",
    "kind": "LinkedField",
    "name": "generateContractNumbers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contractNumbers",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GenerateContractNumbersMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GenerateContractNumbersMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "cde8ec2dd51d3aa6be3ca93bf54e9722",
    "metadata": {},
    "name": "GenerateContractNumbersMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "d30b7c2e0d58eae4c9fad49f58adf9b1";

export default node;
